import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ItemsActions } from './items.actions';
import { ItemsSelectors } from './items.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {ItemSummary} from '@emm/core/models/item-summary.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {getActionQueries} from '@emm/core/util/ngrx.util';


export interface ItemsQueries extends AsyncActionQueries {
    all$: Observable<ItemSummary[]>;
    isEmpty$: Observable<boolean>;
    selected$: Observable<ItemSummary>;
}

@Injectable({
    providedIn: 'root'
})
export class ItemsStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>, private actions$: Actions) {
        super(store, ItemsSelectors);
    }



    dispatch = {
        loadItems: () => this.store.dispatch(ItemsActions.load()),
        selectItem: (item: ItemSummary, dispatchReload: boolean) =>
            this.store.dispatch(ItemsActions.select({ item, dispatchReload }))
    };



    queries: ItemsQueries = {
        all$: this.select(ItemsSelectors.getValidAll).pipe(map((items) => items || [])),
        isEmpty$: this.select(ItemsSelectors.getIsEmpty),
        selected$: this.selectNonNil(ItemsSelectors.getSelectedItem),
        ...this.asyncActionQueries,
        ...getActionQueries({
            actionCreators: ItemsActions,
            actions$: this.actions$
        })
    };



}
